import { render, staticRenderFns } from "./Filtro.vue?vue&type=template&id=4822fb62&scoped=true&"
import script from "./Filtro.vue?vue&type=script&lang=js&"
export * from "./Filtro.vue?vue&type=script&lang=js&"
import style0 from "./Filtro.vue?vue&type=style&index=0&id=4822fb62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4822fb62",
  null
  
)

export default component.exports